import { render, staticRenderFns } from "./MultilineText.vue?vue&type=template&id=2e706a10&"
import script from "./MultilineText.vue?vue&type=script&lang=js&"
export * from "./MultilineText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports